export default __webpack_public_path__ + "static/media/ice.1a02780b.svg";